export const createPipelineTemplate = `
    mutation createPipelineTemplate($input: CreatePipelineTemplateInput!) {
        createPipelineTemplate(input:$input) {
            id
            name
            description
            pipelineType
            archetype
            buildCommand
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
            }
            defaultDeploymentAccounts {
              accountId
              accountName
              region
            }
            createdByUsername
            created
    }
}`;

export const updatePipelineTemplate = `
    mutation updatePipelineTemplate($input: UpdatePipelineTemplateInput!) {
        updatePipelineTemplate(input:$input){
            id
            name
            description
            pipelineType
            archetype
            buildCommand
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
            }
            defaultDeploymentAccounts {
              accountId
              accountName
              region
            }
            createdByUsername
            created
            updated
        }
}`;

export const deletePipelineTemplate = `
    mutation deletePipelineTemplate($input: DeletePipelineTemplateInput!) {
        deletePipelineTemplate(input:$input)
}`;
